import React, { useState } from "react";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import { Button, Modal, Spin } from "antd";
// import './ModalPrivacidad.css';

export const ModalPrivacidad = () => {
  const history = useHistory();
  const [isModalPrivacidad, setIsModalPrivacidad] = useState(true);
  //Aviso
  const { avisoPrivacidad, avisoLoading } = useSelector(
    (state) => state.catalogos
  );
  /**
   * Para mostrar/ocultar el modal de privacidad
   */
  const openOrCloseModalPrivacidad = () => {
    setIsModalPrivacidad((state) => !state);
    history.goBack();
  };

  return (
    <Modal
      title={
        <Spin spinning={avisoLoading}>
          <div className="titulo-aviso-privacidad">
            {avisoPrivacidad.titulo}
          </div>
        </Spin>
      }
      footer={null}
      visible={isModalPrivacidad}
      onCancel={openOrCloseModalPrivacidad}
      keyboard={false}
      maskClosable={false}
      width={500}
      height={500}
      className="main-modal-privacidad"
    >
      <div className="modal-body-container">
        <Spin spinning={avisoLoading}>
          <div
            className="aviso-privacidad-modal"
            dangerouslySetInnerHTML={{ __html: avisoPrivacidad.aviso }}
          />
        </Spin>
        <div className="button-privacidad">
          <center key="privacy">
            <Button
              type="primary"
              onClick={() => {
                setIsModalPrivacidad((state) => !state);
              }}
              disabled={avisoLoading}
            >
              Aceptar y continuar
            </Button>
          </center>
        </div>
      </div>
    </Modal>
  );
};
